export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'ff053a6f-61e9-47dc-8a57-085a459de220';
export const MODAL_CLOSE_SEC = 2.5;
